export const darkTheme = {
  bg: "#09090E",
  bgLight: "#13131F",
  primary: "#8A2BE2",
  primaryLight: "#9D4EDD",
  secondary: "#00F0FF",
  text_primary: "#F2F3F4",
  text_secondary: "#A1A1AA",
  card: "rgba(25, 25, 35, 0.6)",
  card_light: "rgba(35, 35, 50, 0.8)",
  button: "#8A2BE2",
  white: "#FFFFFF",
  black: "#000000",
  glass_border: "rgba(255, 255, 255, 0.05)",
  glass_shadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
};
 
export const lightTheme = {
  bg: "#FFFFFF",
  bgLight: "#F0F3F8",
  primary: "#8A2BE2",
  text_primary: "#111111",
  text_secondary: "#6B7280",
  card: "#FFFFFF",
  button: "#8A2BE2",
};
